import { render, staticRenderFns } from "./CardAlumno.vue?vue&type=template&id=7ef452ed&"
import script from "./CardAlumno.vue?vue&type=script&lang=js&"
export * from "./CardAlumno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports